import { createTheme } from '@mui/material/styles';

import { getRootTheme } from './rootTheme';

export const getThemeLight = () =>
  createTheme({
    ...getRootTheme()
  });
